import {FaTimes} from 'react-icons/fa'
import {FaArrowCircleRight} from 'react-icons/fa'

const PlayerCard =({newPlayer, setClosed})=>{

    const teamColor = newPlayer.team.teamColor
    const cardStyling = {
        background: `linear-gradient(#000000, ${teamColor} 40%)`
    }
    
    return(


        <div id='card-container' style={cardStyling}>
            
            <FaTimes style={{color:"#ffffff",  marginLeft:"auto", cursor: 'pointer'}} onClick={()=>setClosed(false)}/>
            <div id='playerCard-header'>
                <img src={newPlayer.picture} alt='NBA Player' />
                <h3>{newPlayer.name}</h3>
                <p>"{newPlayer.nickName}"</p>
                
            </div>
            <div id='playerCard-information'>
                <ul>
                    <li><strong className='strong'>Current Team: </strong>{newPlayer.team.name}</li>
                    <li><strong className='strong'>Drafted: </strong>{newPlayer.draftDate}</li>
                    <li><strong className='strong'>Positions: </strong> {newPlayer.positions.map((pos, index, array )=> index !== array.length - 1 ? `${pos}, ` : (pos))}</li>
                    <li><strong className='strong'>Born: </strong>{newPlayer.dob}</li>
                    <li><strong className='strong'>Height: </strong>{newPlayer.height}</li>
                    <li><strong className='strong'>Education: </strong>{newPlayer.education}</li>
                </ul>
            </div>
            <div id="playerCard-highlights">
                <a href={newPlayer.highlights} target='_blank' rel="noreferrer"> View Highlights <FaArrowCircleRight /></a>
                
            
            </div>
              



        </div>
    )

   
}


export default PlayerCard